import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children }) => (
  <p className="text-xs font-semibold uppercase tracking-[0.28em] text-corpblue mb-4">{children}</p>
);

export const SectionHeading = ({ eyebrow, title, intro, dark = false }) => (
  <Reveal>
    <div className="max-w-3xl">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2
        className={`text-4xl sm:text-5xl font-semibold leading-[1.05] ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
      {intro && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
          {intro}
        </p>
      )}
    </div>
  </Reveal>
);
